import PropTypes from 'prop-types';

import { When } from 'react-if';

import './ParamBox.scss';

/* key on div is to force rerender when ports are connected */
const ParamBox = ({ action = undefined, icon = undefined, text = "", width = undefined }) => (
  <div 
      className="insight-node-widget__param"
      style={{ width }}
  >
    <div className="insight-node-widget__param__content">
      <When condition={icon}>
        {() => (
          <div className="insight-node-widget__param__content__icon">
            {icon}
          </div>
        )}
      </When>
      <div className="insight-node-widget__param__content__text">
        <p className="insight-node-widget__param__content__text__main">
          {text}
        </p>
      </div>
      <When condition={action}>
        {() => (
          <div className="insight-node-widget__param__content__action">
            {action}
          </div>
        )}
      </When>
    </div>
  </div>
)

ParamBox.propTypes = {
  action: PropTypes.any,
  icon: PropTypes.any,
  text: PropTypes.string,
  width: PropTypes.string,
}

export default ParamBox;